import { createSlice } from "@reduxjs/toolkit";

const generalSlice = createSlice({
  name: "generalSlice",
  initialState: {
    downloadImageTime: 0,
  },
  reducers: {
    setDownloadImageTime: (state, action) => {
      state.downloadImageTime = action.payload;
    },
  },
});

export const { setDownloadImageTime } = generalSlice.actions;

export default generalSlice.reducer;
